import { useState, useEffect } from "react";
import { Stack, useRouter } from "expo-router";
import { View, Text, Pressable } from "react-native";
import { ChevronBackIcon } from "@/components/Icons";
import { colors } from "@/lib/theme";
import StumpsIcon from "@/components/StumpsIcon";
import DevSwitcher from "@/components/DevSwitcher";
import NotificationBell from "@/components/NotificationBell";
import NotificationsDrawer from "@/components/NotificationsDrawer";

function BackButton() {
  const router = useRouter();
  return (
    <Pressable
      onPress={() => router.back()}
      style={{ paddingLeft: 12, paddingVertical: 8, paddingRight: 8 }}
    >
      <ChevronBackIcon size={24} color={colors.brand} />
    </Pressable>
  );
}

function HeaderTitle() {
  return (
    <View style={{ flexDirection: "row", alignItems: "center", gap: 8 }}>
      <StumpsIcon size={24} />
      <Text
        style={{
          fontSize: 18,
          fontWeight: "800",
          color: colors.ink,
          letterSpacing: -0.3,
        }}
      >
        inthecrease
      </Text>
    </View>
  );
}

export default function AppLayout() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const router = useRouter();

  useEffect(() => {
    import("@/lib/pushNotifications").then((m) => m.attachNotificationTapHandler((link) => router.push(link as any))).catch(() => {});
  }, []);

  const sub = (title: string) => ({
    headerTitle: title,
    headerTitleStyle: { fontSize: 17, fontWeight: "700" as const, color: colors.ink },
    headerLeft: () => <BackButton />,
    headerRight: () => <NotificationBell onPress={() => setDrawerOpen(true)} />,
    animation: "slide_from_right" as const,
  });

  return (
    <View style={{ flex: 1 }}>
      <Stack
        screenOptions={{
          headerStyle: { backgroundColor: colors.white },
          headerTitleAlign: "center",
          headerLeftContainerStyle: { width: 60 },
          headerRightContainerStyle: { width: 60 },
          headerShadowVisible: false,
          contentStyle: { backgroundColor: colors.bg },
          headerRight: () => <NotificationBell onPress={() => setDrawerOpen(true)} />,
        }}
      >
        <Stack.Screen name="(tabs)" options={{ headerShown: false }} />
        <Stack.Screen name="match-detail" options={sub("Match")} />
        <Stack.Screen name="training-detail" options={sub("Training")} />
        <Stack.Screen name="create-training" options={sub("New Training")} />
        <Stack.Screen name="edit-training" options={sub("Edit Training")} />
        <Stack.Screen name="training-series" options={sub("Training Series")} />
        <Stack.Screen name="members" options={sub("Members")} />
        <Stack.Screen name="create-fixture" options={sub("Fixture")} />
        <Stack.Screen name="teams" options={sub("Teams")} />
        <Stack.Screen name="pick-captain" options={sub("Select")} />
        <Stack.Screen name="fee-settings" options={sub("Fee Settings")} />
        <Stack.Screen name="club-settings" options={sub("Club Settings")} />
        <Stack.Screen name="create-club" options={sub("New Club")} />
        <Stack.Screen name="import-fixtures" options={sub("Import Fixtures")} />
        <Stack.Screen name="dev-switcher" options={sub("Dev Switcher")} />
        <Stack.Screen name="chat" options={sub("Chat")} />
        <Stack.Screen name="create-channel" options={sub("New Channel")} />
        <Stack.Screen name="help" options={sub("Help & FAQ")} />
        <Stack.Screen name="legal" options={sub("Legal")} />
        <Stack.Screen name="channel-members" options={sub("Members")} />
        <Stack.Screen name="channel-requests" options={sub("Requests")} />
        <Stack.Screen name="channel-invite" options={sub("Invite")} />
        <Stack.Screen name="post-detail" options={sub("Post")} />
        <Stack.Screen name="team-selection" options={sub("Team Selection")} />
        <Stack.Screen name="pay" options={sub("Pay")} />
        <Stack.Screen name="create-event" options={sub("New Event")} />
        <Stack.Screen name="event-detail" options={sub("Event")} />
        <Stack.Screen name="my-fees" options={sub("My Fees")} />
        <Stack.Screen name="finances" options={sub("Finances")} />
        <Stack.Screen name="finances-outstanding" options={sub("Outstanding")} />
        <Stack.Screen name="member-detail" options={sub("Member")} />
        <Stack.Screen name="match-fees" options={sub("Match Fees")} />
        <Stack.Screen name="net-bookings" options={sub("Net Bookings")} />
        <Stack.Screen name="net-session" options={sub("Net Session")} />
        <Stack.Screen name="net-settings" options={sub("Net Settings")} />
        <Stack.Screen name="member-profile" options={sub("My Profile")} />
        <Stack.Screen name="invite-member" options={sub("Invite Member")} />
        <Stack.Screen name="set-password" options={sub("Password")} />
      </Stack>
      <DevSwitcher />
      <NotificationsDrawer visible={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </View>
  );
}
